module.exports = __webpack_public_path__ + "static/1-layer2-072f9ed5620cd0f99ff6ac5ab3d82fd8.svg";